<!-- @format -->

<template>
  <div id="seating-management" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading' && form.tables == null" key="create-loading" />
      <div class="modal-body no-footer" v-else key="content-loading">
        <div v-if="false">
          <upgrade-overlay height="400px"></upgrade-overlay>
        </div>
        <div class="modal-inner" v-else>
          <div class="modal-left">
            <el-row>
              <el-col :span="24" class="seating-filter-container">
                <div class="seating-filter-area">
                  <div>
                    <el-input v-model="filter.searchTerm" :placeholder="$t('components.seatingManagement.placeholderSearchAttendee')" clearable @clear="searchTerm = null"></el-input>
                  </div>
                  <div class="mt-2">
                    <el-select v-model="filter.tagIDs" multiple filterable>
                      <el-option v-for="tag in $store.state.tags.items" :key="tag.id" :label="tag.title" :value="tag.id"></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="mt-2 d-flex flex-column p-1">
                  <draggable :list="participantList" class="participant-list p-2" :group="{ name: 'g1', pull: 'clone' }" draggable=".draggable-item">
                    <div class="participant-list-item" v-for="(participant, index) in participantList" :key="participant.participantId + '-list-' + index" :class="{ 'draggable-item': !form.tables.some(x => x.chairs.some(y => y.participantId == participant.participantId)) }">
                      <ParticipantMini :data="prepareParticipantMini(participant.participant)" :listSelect="form.tables.some(x => x.chairs.some(y => y.participantId == participant.participantId))" />
                    </div>
                  </draggable>
                  <infinite-loading @infinite="getData" :identifier="infiniteId">
                    <div slot="no-more">
                      <span class="mt-2">{{ $t("components.seatingManagement.noOther") }}</span>
                    </div>

                    <div slot="no-results">
                      <span class="mt-2">{{ $t("components.seatingManagement.noFound") }}</span>
                    </div>
                  </infinite-loading>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="modal-right" v-if="form.tables.length > 0">
            <el-row :gutter="16">
              <el-col :span="24" class="position-relative">
                <div class="info-bar">
                  <div class="d-flex align-items-center">
                    <!-- <span class="text-center">{{ form.tables.length }} masa 10 kişi yerleştirildi</span> -->
                    <span class="text-center" v-html="$t('components.seatingManagement.tableNumbers', [form.tables.length, chairsLength])"></span>

                    <el-tag type="info" v-if="loading == 'updateSeating'" class="ml-2">
                      <i class="el-icon-loading"></i>
                      {{ $t("components.seatingManagement.updating") }}
                    </el-tag>
                  </div>
                  <el-button-group>
                    <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                      <el-button @click="$helpMe('https://holacon.com/product-guide/detail/how-to-create-manage-seating-plans')" icon="fas fa-life-ring" size="mini" round></el-button>
                    </el-tooltip>
                    <el-button type="primary" icon="fas fa-plus" @click="newTable" round size="mini">{{ $t("components.seatingManagement.createTable") }}</el-button>
                  </el-button-group>
                </div>
                <div class="tables-area mt-2">
                  <draggable :list="form.tables" class="seating-items" group="b" v-bind="dragOptions" handle=".el-icon-s-grid">
                    <div class="seating-container" v-for="(table, tableIndex) in form.tables" :key="'table-key-' + tableIndex">
                      <div class="seating-header">
                        <span class="seating-header-title"><i class="el-icon-s-grid burger"></i></span>
                        <el-input v-model="table.title" size="medium"></el-input>
                        <el-tooltip class="item" effect="dark" :content="$t('components.seatingManagement.delete')" placement="top">
                          <el-popconfirm class="flex-shrink-0" @confirm="form.tables.splice(tableIndex, 1)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                            <i class="fas fa-trash text-danger" slot="reference"></i>
                            <!-- <el-button slot="reference" size="mini" circle type="danger" icon="fas fa-trash"></el-button> -->
                          </el-popconfirm>
                        </el-tooltip>

                        <!-- <div class="seating-controls">
                      <span @click="categoryId = table.id; addCategoryModal = true;">
                        <i class="fa fa-pen"></i>
                      </span>
                      <span>
                        <i :class="loading == table.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                      </span>
                    </div> -->
                      </div>
                      <draggable :list="table.chairs" group="g1" class="seating-inner-items participant-list">
                        <div class="participant-list-item" v-for="(participant, participantIndex) in table.chairs" :key="participant.participantId + '-group-partici-' + participantIndex + '-rand-' + Math.floor(Math.random() * 10000)">
                          <ParticipantMini :data="prepareParticipantMini(participant.participant)" :removeSelect="true" :key="participant.participantId" :participantIndex="participantIndex" @remove="table.chairs.splice(participantIndex, 1)" />
                        </div>
                      </draggable>
                      <div class="seating-footer">
                        <div class="people-count">{{ table.chairs.length }} {{ $t("components.seatingManagement.person") }}</div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-access-control-lottie'" :title="$t('event.table.seatingPllaner')" @btnAdd="newTable" @btnRefresh="false" :buttonAdd="true" :buttonRefresh="false" :loading="loading" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import _ from "lodash";
import draggable from "vuedraggable";
import ParticipantMini from "./ParticipantMini.vue";
export default {
  props: ["venueId"],
  components: {
    draggable,
    ParticipantMini
  },
  data() {
    return {
      infiniteId: +new Date(),
      loading: false,
      timeout: null,
      searchTerm: null,
      filter: {
        searchTerm: null,
        tagIDs: [],
        skip: 0,
        accessibleVenueId: null,
        take: 20
      },
      participantList: [],
      form: {
        id: null,
        tables: null
      }
    };
  },
  methods: {
    async getData($state) {
      var filter = { ...this.filter, skip: this.participantList.length };
      var res = await this.$store.dispatch("seatingParticipants", filter);
      if (res.data.data.items.length > 0) {
        res.data.data.items.forEach(x => {
          x = {
            title: null,
            participantId: x.id,
            participant: x
          };
          this.participantList.push(x);
        });
        this.participantList = _.uniqWith(this.participantList, _.isEqual);
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        tagID: row.tagID,
        participantNO: row.participantNO,
        id: row.id
      };
    },
    newTable() {
      this.form.tables.push({ id: null, title: this.$t("components.seatingManagement.table") + (this.form.tables.length + 1), chairs: [] });
    }
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    chairsLength() {
      var chairs = 0;
      this.form.tables.forEach(x => {
        chairs += x.chairs.length;
      });

      return chairs;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.venueId != null && this.venueId != undefined) {
        this.form.id = this.venueId;
        this.filter.accessibleVenueId = this.venueId;
        await this.$store.dispatch("getTags");
        var res = await this.$store.dispatch("getSeatingPlan", this.form.id);
        if (!res.data.alert.hasError) {
          this.form.tables = res.data.data.tables;

          this.$watch("form", {
            deep: true,
            async handler() {
              this.loading = "updateSeating";
              if (this.timeout != null) clearTimeout(this.timeout);
              this.timeout = setTimeout(async () => {
                var res = await this.$store.dispatch("updateSeatingPlan", this.form);
                if (res.data.alert.hasError) {
                  this.$emit("closeDialog");
                }
                this.loading = false;
              }, 500);
            }
          });
        } else {
          this.$emit("closeDialog");
        }
      } else {
        this.$emit("closeDialog");
      }
      this.loading = false;
    }, 500);
  },
  watch: {
    filter: {
      deep: true,
      async handler() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch("seatingParticipants", this.filter);
          var mapList = res.data.data.items.map(x => {
            x = {
              title: null,
              participantId: x.id,
              participant: x
            };
            return x;
          });
          this.participantList = mapList;
          this.participantList = _.uniqWith(this.participantList, _.isEqual);
        }, 500);
      }
    }
  }
};
</script>

<style lang="less">
#seating-management {
  & > .modal-body {
    height: calc(~"100vh - 139px");
    overflow: hidden;
  }

  .seating-filter-area {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 2;
    width: 100%;
    padding: 10px;
  }

  .modal-inner {
    display: grid;
    flex-direction: column;
    grid-template-columns: 1.2fr 4fr;
    gap: 10px;
    height: 100%;

    .modal-left {
      overflow-y: scroll;
      overflow-x: hidden;
      padding: 0px 6px;
      position: relative;
    }

    .modal-right {
      overflow-y: scroll;
      overflow-x: hidden;
      position: relative;
      padding: 0px 6px;
    }
  }

  .participant-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: hidden;
    .participant-list-item {
      user-select: none;
    }
  }
  .info-bar {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    background-color: white;
    min-height: 40px;
    display: flex;
    z-index: 2;
    top: 0;
    height: 40px;
    align-items: center;
    justify-content: space-between;
  }
  .seating-items {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;

    .seating-container {
      background-color: #fbfbfb;
      border: 0.5px solid #f1f3f6;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      border-radius: 8px;
      position: relative;

      .seating-header {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: #f1f1f1;
        padding: 10px 14px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        &.passive {
          background-color: #fff2f2;
        }

        span {
          flex-shrink: 0;
          justify-content: center;
          display: flex;
          align-items: center;
          min-height: 28px;
          width: 28px;
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 220px;

          i {
            font-size: 20px;
          }

          &:last-child {
            i {
              font-size: 16px;
              cursor: pointer;
            }
          }
        }

        .seating-header-title {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 32px;
          height: 32px;
          cursor: grab;

          &.burger {
            box-sizing: border-box;
            font-size: 20px;
            color: #505763;
          }
        }
      }

      .seating-inner-items {
        width: 100%;
        min-height: 260px;
        // max-height: 280px;
        // overflow-y:auto;
        padding: 8px;
        position: relative;
        height: 100%;

        & > span {
          min-height: 260px;
          height: 100%;
          display: block;
        }
      }

      .seating-footer {
        padding: 6px 0px 6px;
        .people-count {
          background-color: white;
          border: 2px solid #268ea6;
          border-radius: 1rem;
          font-size: 12px;
          font-weight: bold;
          padding: 5px 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SeatingManagement.vue